import { inject, observer } from 'mobx-react'
import * as React from 'react'
import { NextButton } from '../../../../../../shared/components/Button'
import { Headline, HeadlineCSS } from '../../../../../../shared/components/Headlines'
import { Jaw } from '../../../../../../shared/Constants'
import { breakpoint, styled } from '../../../../../../shared/styled-components'
import { Utils } from '../../../../../../shared/Utils'
import { CalculatorStoreInstance } from '../../../../../../stores/CalculatorStore'
import { Text } from '../../../../../../shared/components/Elements'

interface IProps {
  jaw: Jaw
  store?: CalculatorStoreInstance
  onSwitchToConfig?: () => void
}

@inject('store')
@observer
export class JawReplacementRecommendationOverview extends React.Component<IProps> {
  // -------------------------------------------------------------------------- HELPERS

  private _getRecommendations () { return this.props.store!.offer.getJawRecommendations(this.props.jaw) }
  private _getRequirement () { return this.props.store!.offer.getJawRequirement(this.props.jaw) }

  private get _imageFileName () {
    const recommendations = this._getRecommendations()
    const requirement = this._getRequirement()
    const { jaw } = this.props
    if (!requirement.removable) {
      return `${jaw}_jaw_non_removable`
    }
    return `${jaw}_jaw_${recommendations[0].attachmentType}_${recommendations[0].count}`
  }


  // -------------------------------------------------------------------------- RENDERING

  render (): React.ReactNode {
    const recommendation = this._getRecommendations()[0]
    const requirement = this._getRequirement()

    let attachmentType
    switch (recommendation.attachmentType) {
      case 'locator':
        attachmentType = 'Locatoren'
        break
      case 'telescope':
        attachmentType = 'Teleskope'
        break
      case 'bridge':
        attachmentType = 'Stegkonstruktion'
        break
    }

    if (!requirement.removable) {
      attachmentType = 'Festsitzend'
    }

    return (<Container>
      <Left>
        <LeftHeadline>Zahnersatz {requirement.removable ? 'herausnehmbar' : 'festsitzend'}</LeftHeadline>
        <RecommendationImage src={Utils.getAssetPath(`/assets/calculator/${this._imageFileName}.png`)}/>
      </Left>
      <Right>
        <SmallerHeadline>{recommendation.count} Implantate</SmallerHeadline>
        <SmallerHeadline>Befestigung: {attachmentType}</SmallerHeadline>

        <TextWithMargin>
          {requirement.removable
            ? 'Möchten Sie sich für eine andere Anzahl an Implantaten oder für eine andere Befestigungsart entscheiden?'
            : 'Bei einem festsitzenden Zahnersatz für einen zahnlosen Kiefer entscheidet der Behandler, ob die prothetische Versorgung verschraubt oder zementiert wird.'}
        </TextWithMargin>

        {requirement.removable && <NextButton primary onClick={this.props.onSwitchToConfig}>Auswahl anpassen</NextButton>}
      </Right>
    </Container>)
  }
}

const Container = styled.div`
  display: flex;
  flex-direction: column;
  ${breakpoint('tablet')`
    flex-direction: row;
  `}
`

const LeftHeadline = styled(Headline)`
  margin-bottom: 0.5em;
`

const Left = styled.div`
  flex: 1 1 0;
  ${breakpoint('tablet')`
    margin-right: 50px;
    border-right: 1px solid ${props => props.theme.borderColor};
  `}
`

const Right = styled.div`
  flex: 1 1 0;
  padding-top: 30px;
`

const SmallerHeadline = styled.h2`
  ${HeadlineCSS};
  font-weight: ${props => props.theme.subHeadlineWeight};
  font-size: 22px;
  margin-bottom: 1em;
`

const TextWithMargin = styled(Text)`
  margin-bottom: 2em;
`

const RecommendationImage = styled.img`
  width: 330px;
`
